/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum TranscodeStatus {
  Awaiting = "Awaiting",
  Processing = "Processing",
  Complete = "Complete",
  Error = "Error",
}

export enum MediaType {
  Audio = "Audio",
  Video = "Video",
}

export interface EmptyValueApiResponse {
  hasErrors?: boolean;
  errors?: Record<string, string | null>;
  value?: any | null;
}

export interface FilePartEtag {
  /** @format int32 */
  partNumber?: number;
  eTag?: string | null;
  checksumCRC32?: string | null;
  checksumCRC32C?: string | null;
  checksumSHA1?: string | null;
  checksumSHA256?: string | null;
}

export interface FilePartUploadModel {
  /** @format int32 */
  partNumber?: number;
  partUploadUri?: string | null;
}

export interface FileUploadCompleteRequest {
  /** @minLength 1 */
  originalFileName: string;
  /**
   * @minLength 1
   * @pattern ^(audio|video|multipart|application)/([A-Za-z0-9-.+_]+)$
   */
  mimeType: string;
  mediaType: MediaType;
  /**
   * @format double
   * @min 1
   */
  size: number;
  /**
   * @minLength 1
   * @pattern ^[A-Za-z0-9_\-\.]{1,100}$
   */
  s3ObjectKey: string;
  isMultipartUpload: boolean;
  /** @pattern ^[A-Za-z0-9_\-\.]+$ */
  multipartUploadId?: string | null;
  partETags?: FilePartEtag[] | null;
}

export interface FileUploadCompleteResponse {
  hasErrors?: boolean;
  errors?: Record<string, string | null>;
  value?: MediaFileMetadata;
}

export interface FileUploadModel {
  id?: string | null;
  name?: string | null;
  mimeType?: string | null;
  /** @format double */
  size?: number;
  uploadUri?: string | null;
  isMultipartUpload?: boolean;
  multipartUploadId?: string | null;
  partInfo?: FilePartUploadModel[] | null;
  s3ObjectKey?: string | null;
  /** @format double */
  chunkSize?: number;
}

export interface FileUploadResponse {
  hasErrors?: boolean;
  errors?: Record<string, string | null>;
  value?: FileUploadModel;
}

export interface Media {
  /** @format uuid */
  id?: string;
  originalFileName?: string | null;
  s3ObjectKey?: string | null;
  /** @format double */
  size?: number;
  mimeType?: string | null;
  mediaType?: MediaType;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  modified?: string;
  /** @format uuid */
  ownerId?: string;
  transcodeStatus?: TranscodeStatus;
  /** @format double */
  durationInMs?: number | null;
  outputFiles?: OutputFileResult[] | null;
  thumbnails?: string[] | null;
}

export interface MediaCollectionResponse {
  hasErrors?: boolean;
  errors?: Record<string, string | null>;
  value?: Media[] | null;
}

export interface MediaFileMetadata {
  /** @format uuid */
  id?: string;
  originalFileName?: string | null;
  s3ObjectKey?: string | null;
  /** @format double */
  size?: number;
  mimeType?: string | null;
  mediaType?: MediaType;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  modified?: string;
}

export interface MediaItemMetadataRequest {
  mediaItemIds?: string[] | null;
  /** @format int64 */
  maxSize?: number;
}

export interface MediaItemMetadataResponse {
  /** @format int64 */
  totalSize?: number;
}

export interface MediaItemStitchResponse {
  /** @format uuid */
  mediaItemId?: string;
  transcodeJobId?: string | null;
}

export interface MediaResponse {
  hasErrors?: boolean;
  errors?: Record<string, string | null>;
  value?: Media;
}

export interface OutputFileResult {
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
  /** @format double */
  durationInMs?: number;
  objectUrls?: string[] | null;
  outputGroupType?: string | null;
  /** @format int64 */
  s3ObjectSize?: number;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface StitchMediaItem {
  /** @format int32 */
  order?: number;
  /** @format uuid */
  mediaItemId?: string;
}

export interface StitchMediaRequest {
  /** @minItems 2 */
  input: StitchMediaItem[];
  /**
   * @minLength 1
   * @pattern ^[A-Za-z0-9_\-\.]{1,100}$
   */
  outputFileName: string;
}

export interface UpdateMediaItemRequest {
  name?: string | null;
}

export interface WhoamiResponse {
  /** @format uuid */
  userId?: string;
  userName?: string | null;
  role?: string | null;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Spotlight Core Media API
 * @version v1
 * @contact Ben Shearer
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  containerHealth = {
    /**
     * No description
     *
     * @tags ContainerHealth
     * @name ContainerHealthGetStatus
     * @request GET:/container_health
     * @secure
     */
    containerHealthGetStatus: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/container_health`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  apiHealth = {
    /**
     * No description
     *
     * @tags HealthCheck
     * @name HealthCheckGetStatus
     * @request GET:/api_health
     * @secure
     */
    healthCheckGetStatus: <TResponse = unknown, TError = unknown>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/api_health`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  titanium = {
    /**
     * No description
     *
     * @tags Media
     * @name MediaGetMediaItemMetadataByIds
     * @request POST:/titanium/media
     * @secure
     */
    mediaGetMediaItemMetadataByIds: <
      TResponse = MediaItemMetadataResponse,
      TError = EmptyValueApiResponse,
    >(
      data: MediaItemMetadataRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/titanium/media`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaGetMediaItemsByOwnerId
     * @request GET:/titanium/media
     * @secure
     */
    mediaGetMediaItemsByOwnerId: <
      TResponse = MediaCollectionResponse,
      TError = EmptyValueApiResponse | ProblemDetails,
    >(
      query?: {
        /** @format uuid */
        ownerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/titanium/media`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaGetMediaItemById
     * @request GET:/titanium/media/{id}
     * @secure
     */
    mediaGetMediaItemById: <
      TResponse = MediaResponse,
      TError = EmptyValueApiResponse,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/titanium/media/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaDeleteMediaItem
     * @request DELETE:/titanium/media/{id}
     * @secure
     */
    mediaDeleteMediaItem: <
      TResponse = EmptyValueApiResponse,
      TError = EmptyValueApiResponse | ProblemDetails,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/titanium/media/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Media
     * @name MediaUpdateMediaItem
     * @request PUT:/titanium/media/{id}
     * @secure
     */
    mediaUpdateMediaItem: <
      TResponse = MediaResponse,
      TError = EmptyValueApiResponse | ProblemDetails,
    >(
      id: string,
      data: UpdateMediaItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/titanium/media/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stats
     * @name StatsWriteInStatistic
     * @request POST:/titanium/stats/{mediaid}
     * @secure
     */
    statsWriteInStatistic: <TResponse = unknown, TError = any>(
      mediaid: string,
      query?: {
        /** @format uuid */
        userId?: string;
        userRole?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/titanium/stats/${mediaid}`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name UploadGetFileUpload
     * @request GET:/titanium/upload
     * @secure
     */
    uploadGetFileUpload: <
      TResponse = FileUploadResponse,
      TError = EmptyValueApiResponse | ProblemDetails,
    >(
      query: {
        Name: string;
        MimeType: string;
        /**
         * @format double
         * @min 1
         */
        Size: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/titanium/upload`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name UploadFinishFileUpload
     * @request POST:/titanium/upload
     * @secure
     */
    uploadFinishFileUpload: <
      TResponse = FileUploadCompleteResponse,
      TError = EmptyValueApiResponse | ProblemDetails,
    >(
      data: FileUploadCompleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/titanium/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name UploadStitch
     * @request POST:/titanium/upload/stitch
     * @secure
     */
    uploadStitch: <
      TResponse = MediaItemStitchResponse,
      TError = EmptyValueApiResponse,
    >(
      data: StitchMediaRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/titanium/upload/stitch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  whoami = {
    /**
     * No description
     *
     * @tags Whoami
     * @name WhoamiGetUserInformation
     * @request GET:/whoami
     * @secure
     */
    whoamiGetUserInformation: <
      TResponse = WhoamiResponse,
      TError = ProblemDetails,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/whoami`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
